import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ticket.svg",
  "use": "Ticket.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Ticket.svg\"><path d=\"M53.0208,49.0208h-42a3,3,0,0,1-3-3V39.4127A3.0561,3.0561,0,0,1,9.967,36.628a5.0022,5.0022,0,0,0,0-9.2143,3.0562,3.0562,0,0,1-1.9462-2.7848V18.0208a3,3,0,0,1,3-3h42a3,3,0,0,1,3,3v6.6081a3.056,3.056,0,0,1-1.9462,2.7848,5.0022,5.0022,0,0,0,0,9.2143,3.056,3.056,0,0,1,1.9462,2.7847v6.6082A3,3,0,0,1,53.0208,49.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol